import { render, staticRenderFns } from "./CommonFooterButtons.vue?vue&type=template&id=4b720b2e&scoped=true&"
import script from "./CommonFooterButtons.vue?vue&type=script&lang=js&"
export * from "./CommonFooterButtons.vue?vue&type=script&lang=js&"
import style0 from "./CommonFooterButtons.vue?vue&type=style&index=0&id=4b720b2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b720b2e",
  null
  
)

export default component.exports